var map = {
	"./banana.gif": 7086,
	"./crown.gif": 1176,
	"./ghostface.gif": 7614,
	"./grabber.gif": 7233,
	"./gun.gif": 4719,
	"./hannibal.gif": 6407,
	"./jason.gif": 8677,
	"./leatherface.gif": 2994,
	"./mask.gif": 3638,
	"./michael.gif": 7558,
	"./none.gif": 6354,
	"./rainbow-border.gif": 6039,
	"./santa.gif": 7633
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 453;